/**
 * `/@api/membership/event` 호출 시 사용하는 이벤트 타입
 */
export const MEMBERSHIP_EVENT_TYPE = {
  UPDATE_MEMBERSHIP: 'UPDATE_MEMBERSHIP',
} as const;
